module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.e30f330d.jpg";